import { ReactComponent as Arrow } from '../../Icons/bigger-box.svg'
import Button from '../../Components/Button'
import type { IItem } from '../../Items/IItem'
import { openContent } from '../../Content/Content.actions'
import { TabTypes } from '../../Content/IContent'
import { isItemPublished } from '../../List/helpers'
import { useAppDispatch } from '../../Store/hooks'

type DragRendererProps = {
  data: IItem
}

export const DragCellRenderer = ({ data }: DragRendererProps) => {
  const dispatch = useAppDispatch()
  return (
    <Button
      clickHandler={() =>
        dispatch(
          openContent(
            {
              type: TabTypes.Item,
              id: data.id!,
              name: data.header,
              selected: true,
            },
            data.header
          )
        )
      }
      icon={<Arrow />}
      variant="action"
      disable={isItemPublished(data.publishResult)}
      className="d-flex mr-2"
    />
  )
}
